<template>
  <b-link
    :to="{ name: 'Student', params: { id: studentId } }"
    v-b-tooltip.hover
    title="Þátttakandi skráður í hóp. Breyttu upplýsingum á þátttakandaspjaldi."
  >
    <i class="fa fa-fw fa-external-link"></i>
  </b-link>
</template>

<script>
export default {
  name: 'pgp-edit-redirect-link',
  props: {
    studentId: { type: String, required: true },
  },
};
</script>
